module.exports = __webpack_public_path__ + "img/038-sofa.1ee8894.svg";